module.exports = __webpack_public_path__ + "KaTeX_Main-Regular.8963c6b5.woff";